import MuiBox, { BoxProps as MuiBoxProps } from "@mui/material/Box";
import { getHorizontalScrollbarHeight, getVerticalScrollbarWidth } from "csi/utility/htmlUtility";
import React, { FunctionComponent, useState } from "react";
import { mergeRefs } from "react-merge-refs";
import useResizeObserver from "use-resize-observer";

export interface AccommodateScrollBarBoxProps extends Omit<MuiBoxProps, "padding" | "paddingRight" | "paddingBottom" | "overflow"> {
	layout: "vertical" | "horizontal";
};

const AccommodateScrollBarBox: FunctionComponent<AccommodateScrollBarBoxProps> = (props) => {
	const [verticalOverflows, setVerticalOverflows] = useState<boolean>(false);
	const [horizontalOverflows, setHorizontalOverflows] = useState<boolean>(false);
	const { ref } = useResizeObserver<HTMLDivElement>();
	const { layout, ...otherProps } = props;

	const isHorizontal = layout === "horizontal";
	let paddingBottom;
	let paddingRight;

	if (isHorizontal) {
		paddingBottom = horizontalOverflows ? 0 : `${getHorizontalScrollbarHeight()}px`;
		paddingRight = "unset";
	} else {
		paddingRight = verticalOverflows ? 0 : `${getVerticalScrollbarWidth()}px`;
		paddingBottom = "unset";
	}

	// TO DO - what if we need to handle the vertical and horizontal simultaneously
	const mergedRef = mergeRefs([
		ref,
		(element: HTMLDivElement) => {
			if (element) {
				const { clientHeight, clientWidth, scrollHeight, scrollWidth } = element;

				if (isHorizontal) {
					setHorizontalOverflows(scrollWidth > clientWidth);
				} else {
					setVerticalOverflows(scrollHeight > clientHeight);
				}
			}
		},
	]);


	return (
		<MuiBox
			overflow="auto"
			paddingBottom={paddingBottom}
			paddingRight={paddingRight}
			{...{ ref: mergedRef }}
			{...otherProps}
		/>
	);
};

export default AccommodateScrollBarBox;